import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import store from './store/store';
import SubscriberType from './contracts/subscriberType';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import { HMPlusBit } from 'owa-domain-connect';
var lazyFullModule = new LazyModule(() => import('./lazyFullEnrollOption'));
let DomainEnrollOption: LazyOption = createLazyOption(
    {
        key: 'domainenroll',
        titleStringKey: 'options_premiumSubOption_PersonalEmail',
        searchTermsStringKey: 'options_premiumSubOption_PersonalEmail',
        hideTitleInFullOptions: false,
        isHidden: isOptionHidden,
    },
    lazyFullModule,
    m => m.default
);
function isOptionHidden(): boolean {
    var isHidden = true;
    if (store.subscriberType == SubscriberType.Primary && !store.domainState.isDomainCreated) {
        isHidden = false;
    } else if (
        store.subscriberType == SubscriberType.Secondary &&
        !store.userInfo.isProsumerConsumerMailbox &&
        (store.domainState.isDomainCreated || store.domainState.isValid)
    ) {
        isHidden = false;
    }
    return (
        !isFeatureEnabled('auth-domainConnect') ||
        !isFeatureEnabled('auth-PremiumDashboardApril') ||
        !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
        (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) == HMPlusBit ||
        isHidden
    );
}
export default DomainEnrollOption;
